var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-5"},[_c('b-row',[_c('b-col',{attrs:{"offset":"0","cols":"12","offset-md":"3","md":"6"}},[_c('registration-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }